<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="38"
    viewBox="0 0 30 38"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7829 7.42652V3.6671L26.4096 11.4522H18.7829V7.42652ZM29.9748 12.3883C29.9685 12.341 29.9579 12.2959 29.9474 12.2509C29.899 12.0727 29.8254 11.9009 29.6929 11.7656L29.6908 11.7635L18.4779 0.317758L18.4758 0.315611C18.3412 0.180349 18.1729 0.103057 17.9983 0.0558223C17.9562 0.0450872 17.9142 0.0364991 17.8721 0.0300581C17.8237 0.023617 17.7817 0 17.7312 0H1.05167C0.471149 0 0 0.480931 0 1.07351V36.9265C0 37.5191 0.471149 38 1.05167 38H28.9483C29.531 38 30 37.5191 30 36.9265V12.5257C30 12.4763 29.9811 12.4355 29.9748 12.3883Z"
    />
  </svg>
</template>
